import Alpine from 'alpinejs'
import MeilisearchClient from '@modules/meilisearch';

import type { GetResultsType, MeilisearchResponse, SearchHit } from '@utils/types/search';

declare module 'alpinejs' {
    interface Stores {
        quickSearch: {
            client: MeilisearchClient | null
            open: boolean
            hits: SearchHit[]
            query: string
            isLoading: boolean
            attributesToRetrieve: string[]
            initialize: () => void
            hasNoResults: () => boolean
            getResults: (
                query: string,
                offset?: number
            ) => Promise<void | GetResultsType<SearchHit>>
        }
    }
}

const attributesToRetrieve = [
    'title',
    'uid',
    'url',
]

Alpine.store('quickSearch', {
    client: null,
    open: false,
    hits: [],
    query: '',
    isLoading: false,
    attributesToRetrieve,
    initialize() {
        if(!this.client) {
            return console.error('No client found');
        }
    },
    hasNoResults(this: { hits: SearchHit[] }) {
        return this.hits.length === 0
    },
    async getResults(query) {
        this.query = query

        const loadingTimeoutId = setTimeout(() => {
            this.isLoading = true
        }, 500)


        const params = new URLSearchParams({
            q: query,
            attributesToRetrieve: this.attributesToRetrieve.join(','),
        });

        let data: MeilisearchResponse<SearchHit> | null = null;

        if (this.client) {
            data = await this.client.getResults<SearchHit>(params);
        }

        clearTimeout(loadingTimeoutId)

        if (!data) {
            this.isLoading = false;
            return console.error(
                'Something went wrong while fetching the results'
            )
        }

        this.isLoading = false
        this.hits = data.hits || []
    },
})

type QuickSearchInit = {
    host: string
    apiKey: string
    indexUid: string
    query?: string
    attributes?: string[]
}

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('quickSearch', (data: QuickSearchInit) => {
        Alpine.store('quickSearch').client = new MeilisearchClient({
            host: data.host,
            apiKey: data.apiKey,
            index: data.indexUid,
        }, 4)

        if (data.query) {
            Alpine.store('quickSearch').query = data.query
        }

        if (data.attributes) {
            const combinedAttributes = attributesToRetrieve.concat(data.attributes)
            Alpine.store('quickSearch').attributesToRetrieve = [...new Set(combinedAttributes)]
        }

        Alpine.store('quickSearch').initialize()
    })
})
